import React, { ReactElement } from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';
import { MealCreditCreatePage } from 'src/components/oneCorp/features/MealCredit/components/CreatePage/MealCreditCreatePage';
import { MealCreditEditDetailsPage } from 'src/components/oneCorp/features/MealCredit/components/DetailsPage/MealCreditEditDetailsPage';
import { MealCreditPaths } from 'src/components/oneCorp/features/MealCredit/components/Routes/MealCreditPathsDictionary';

export function MealCreditPageRoutes(): JSX.Element {
  return (
    <Switch>
      <Route
        path={MealCreditPaths.create}
        render={(): ReactElement => <MealCreditCreatePage />}
      />
      <Redirect
        exact
        from={MealCreditPaths.mealCreditId}
        to={MealCreditPaths.details}
      />
      <Route
        path={MealCreditPaths.mealCreditId}
        render={(): ReactElement => <MealCreditEditDetailsPage />}
      />
    </Switch>
  );
}
